







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PercentileLabel extends Vue {
  @Prop({
    default: 0
  })
  public value!: number;

  @Prop({
    default: false
  })
  public double!: boolean;

  get lang() {
    return this.$store.state.lang;
  }

  get extension() {
    if (this.lang === 'es') return '';
    switch (this.value % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

}
